declare let $crisp: {
  push: (v: any) => void;
} | null;

// When true, the chat stays hidden even if something (e.g. a closing modal) calls showChat().
// Used by flows that must never show the chat, like the public "update preferences" stepper.
let forceHidden = false;

export default class CrispHelper {
  static hideChat() {
    $crisp?.push(["do", "chat:hide"]);
  }

  static showChat() {
    if (forceHidden) return;
    if (!canShowChat()) return;
    $crisp?.push(["do", "chat:show"]);
  }

  // Keep the chat hidden across a whole flow, overriding intermittent showChat() calls.
  static setForceHidden(v: boolean) {
    forceHidden = v;
    if (v) {
      this.hideChat();
    } else {
      this.showChat();
    }
  }
}

export const canShowChat = () => {
  return true;
  // return process.env.ENVIRONMENT === "Production";
};
